import { useCallback } from 'react';
import { useAppDispatch } from 'App/store';
import { resetUpdateAuthenticationFactor } from 'domains/Account/accountSlice';

function useResetUpdateAuthenticationFactor() {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(resetUpdateAuthenticationFactor());
  }, [dispatch]);
}

export default useResetUpdateAuthenticationFactor;
